import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueFormWizard from 'vue-form-wizard';
import VueRouter from 'vue-router';
import PortalVue from 'portal-vue';
import VueCompositionApi from '@vue/composition-api';

Vue.use(VeeValidate);
Vue.use(VueFormWizard);
Vue.use(PortalVue);
Vue.use(VueCompositionApi);

// Don't install the router automatically when running tests - this prevents some components from mocking $router.
if (process.env.NODE_ENV !== 'test') {
  Vue.use(VueRouter);
}
